import { FC, SetStateAction, useState } from "react";
import CreateTagModal from ".";
import { useDispatch } from "react-redux";
import { ICreateTagModalController } from "./indexModal";
import { useTranslation } from "react-i18next";

const CreateTagController: FC<ICreateTagModalController> = (props) => {
    const dispatch = useDispatch();

    const [showFeedbackName, setShowFeedbackName] = useState(false);
    const [showFeedbackExample, setShowFeedbackExample] = useState(false);
    const [showFeedbackLabel, setShowFeedbackLabel] = useState(false);
    
    const { t } = useTranslation();

    const [optionsType, setOptionsType] = useState([
        { value: "consumer.name", label: t("home_departments.template_message_tab.name_consumer") },
        { value: "consumer.email", label: t("home_departments.template_message_tab.email_consumer") },
        { value: "consumer.phone", label: t("home_departments.template_message_tab.phone_consumer") },
        { value: "ticket.ticket_reference_id", label: t("home_departments.template_message_tab.ticket_number") },
        { value: "employee.name", label: t("home_departments.template_message_tab.name_agent") },
        { value: "general.type", label: t("home_departments.template_message_tab.general_type") },
    ]);
    const [selectedType, setSelectedType] = useState([]);

    /* const hideCreateParamModal = () => {
        props.dispatch(setShowCreateParamModal(false));
    } */

    return <CreateTagModal 
        showFeedbackName={showFeedbackName}
        setShowFeedbackName={setShowFeedbackName}
        showFeedbackLabel={showFeedbackLabel}
        setShowFeedbackLabel={setShowFeedbackLabel}
        dispatch={dispatch}
        tags={props.tags}
        setTags={props.setTags}
        hideTagModal={props.hideTagModal}
        optionsType={optionsType}
        setOptionsType={setOptionsType} 
        selectedType={selectedType} 
        setSelectedType={setSelectedType}  
        showFeedbackExample={showFeedbackExample}  
        setShowFeedbackExample={setShowFeedbackExample}  
        createInCompany={props.createInCompany}
        examples={props.examples}
        setExamples={props.setExamples}
        t={t}
    />
}

export default CreateTagController;